import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen, faDownload } from '@fortawesome/free-solid-svg-icons';

// Function to download XML data
function downloadXML() {
    const element = document.createElement('a');
    const file = new Blob([document.getElementById('XMLdata').textContent], { type: 'text/xml' });
    element.href = URL.createObjectURL(file);
    element.download = 'metadata.xml';
    document.body.appendChild(element);
    element.click();
}

// Function to navigate to a specific URL
// function navigateToURL(url) {
//     window.location.href = url;
// }

// Button component
export default function CustomButton(props) {
    switch (props.type) {
        case 'upload':
            return (
                <div className="button">
                    <label htmlFor="single">
                        <>
                            <FontAwesomeIcon icon={faFolderOpen} color="#3B5998" size="3x" />
                            <br />
                            Ladda upp
                        </>
                    </label>
                    <input type="file" id="single" onChange={props.onChange} />
                </div>
            );
        case 'download':
            return (
                <div className="button" onClick={downloadXML}>
                    <FontAwesomeIcon icon={faDownload} color="#3B5998" size="3x" />
                    <br />
                    Ladda ner
                </div>
            );
        case 'publish':
            return (
                <div className="button"> {/* Add the "publish-button" class */}
                    <a href="https://www.skolfederation.se/teknisk-information/metadata-2/" target="_blank" rel="noopener noreferrer">
                        <FontAwesomeIcon icon={faFolderOpen} size="3x" />
                        <br />
                        <span className="button-text">Publicera</span>
                    </a>
                </div>
            );
        default:
            return null;
    }
}
